// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__vY0F0","left_component":"Overview_left_component__A4cNB","right_component":"Overview_right_component__3Pu_2"};